import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {useLoaderData, useNavigate} from "react-router-dom";
import * as Bank from "../index";
import {BankPrepareAddFormResponse} from "../../../types/modules/bank/response";
import {StoreContext} from "../../../store.context";

export const Add: React.FC = observer(() => {
    const { appStore: {
        moduleStore: { bankStore: { add }},
    }} = useContext(StoreContext);

    const navigate = useNavigate();

    const data: BankPrepareAddFormResponse = useLoaderData() as BankPrepareAddFormResponse;

    const onCancel = () => {
        navigate(`/bank`)
    }

    return <Bank.Form onSave={add} onCancel={onCancel} preparedData={data} />
})